import React, { useState, useEffect, useRef } from "react";
import FontPicker from "font-picker-react";
import TabbedPanel from "../../../../components/TabbedPanel/TabbedPanel";
import FormDropDown from "../../../../components/forms/DropDownList/FormDropDown";
import { applyFontPreview, FontPreviewBlock, getCustomFontUrl } from "../../../../helpers/CustomFonts";
import { slideOutPanelControl } from "../SlideoutPanel";
import './CsvUploaderContent.scss';
import { getCustomisationFieldData, getGroupData } from "../../../../components/v2/CustomisationWorkspace/WorkspaceComponents/EditablePreview/EditablePreview";
import Toggle from "../../../../components/v2/CustomisationWorkspace/WorkspaceComponents/ModuleList/customFields/toggle/toggleSwitch/Toggle";

import Papa from "papaparse";
import { WORKING_ON_NODE_DATA } from "../../../../components/v2/CustomisationWorkspace/WorkspaceComponents/EditablePreview/VisualisedComponents/VisualisedNode";
import { addVal } from "../../../../components/v2/CustomisationWorkspace/v2IntegrationHelpers/CampaignAndFeatureDataHelperFunctions";

const CsvUploaderContent = (props) => {
    console.log("Rendering CsvUploaderContent with props:", props);

    const [currentTab, setCurrentTab] = useState('upload');
    const handleTabSwitch = (tabId, tabData) => {
        setCurrentTab(tabData.id);
    };

    const tabData = [
        { label: 'Upload CSV File', id: 'upload' },
        { label: 'Download CSV File', id: 'download' }
    ];

    const [includedExistingRows, setIncludedExistingRows] = useState([]);
    const [existingData, setExistingData] = useState([]);
    const getExistingData = () => {
        const existingRawData = getGroupData(props.fieldData.customisationVars, props.fieldData?.config?.groupSettings?.dataLink, -1, true);
        console.log("Existing data for CSV download:", existingRawData);
        // return existingData;
        const processedData = [];
        if (existingRawData && Array.isArray(existingRawData)) {
            existingRawData.forEach((row, index) => {
                const rowData = [];
                rowData.push(row.question);
                for (let i = 1; i <= props.csvUploaderData.fields.length; i++) {
                    if (!row[`answer${i}`] || row[`answer${i}`] === '') break;
                    rowData.push(row[`answer${i}`]);
                }
                processedData.push(rowData);
            });
        }
        console.log("Processed data for CSV download:", processedData);
        return processedData;
    };
    useEffect(() => {
        // if (currentTab === 'download') {
            const data = getExistingData();
            setExistingData(data);
            const includedRows = data.map((row, index) => true); // Include all rows by default
            setIncludedExistingRows(includedRows);
        // }
    }, []);

    const downloadExistingDataAsCsv = () => {
        const csvData = Papa.unparse(existingData.filter((row, index) => includedExistingRows[index]));

        const csvContent = `data:text/csv;charset=utf-8,${csvData}`;
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        // replace spaces with underscores and convert to lowercase for the filename, remove any special characters that are not allowed in filenames
        link.setAttribute("download", `${props.fieldData.name.replace(/\s+/g, '_').toLowerCase().replace(/[^a-z0-9_]/g, '')}_exported_${new Date().toLocaleDateString().replace(/[/\\_:.]/g, '-')}.csv`);
        document.body.appendChild(link); // Required for FF

        link.click();
        document.body.removeChild(link);
    };

    const [processingCsvFile, setProcessingCsvFile] = useState(false);
    const [processedCsvData, setProcessedCsvData] = useState([]);
    const [replaceCurrentQuestions, setReplaceCurrentQuestions] = useState(false);
    const [includedNewRows, setIncludedNewRows] = useState([]);
    // const [allowUpdateFromPreview, setAllowUpdateFromPreview] = useState(false);
    // const [showCsvDataPreview, setShowCsvDataPreview] = useState(false);

    const csvInputRef = useRef(null);
    const chooseCsvFile = (e) => {
        e.preventDefault();
        if (!processingCsvFile) {
            csvInputRef.current.click();
        }
    }
    const handleCsvFile = (e) => {
        setProcessingCsvFile(true);
        console.log('handleCsvFile', e);

        Papa.parse(e.target.files[0], {
            complete: function(results) {
                console.log(results);

                // Now we have the csv data, we can process it into an object we can use to preview the data
                let csvData = results.data;
                let processedCsvData = [];
                for (let i = 0; i < csvData.length; i++) {
                    let row = csvData[i];
                    const processedRow = [];
                    for (let j = 0; j < props.csvUploaderData.fields.length; j++) {
                        const cell = row[j] ? row[j].trim() : '';
                        if (cell === '') {
                            // If we encounter an empty cell, we stop processing further cells in this row
                            break;
                        }
                        processedRow.push(cell);
                    }
                    // Only add the row if it has a question (first cell)
                    // if (processedRow[0]) {
                        processedCsvData.push(processedRow);
                    // }
                }

                // randomiseAnswerOrder(processedCsvData, false);
                setProcessedCsvData(processedCsvData);
                setReplaceCurrentQuestions(true);
                setIncludedNewRows(processedCsvData.map(() => true));
                // setAllowUpdateFromPreview(true);
                // setShowCsvDataPreview(true);

                console.log('Processed csv data', processedCsvData);
            }
        });
    }

    const insertCsvData = (dataToInsert, replaceExisting) => {
        const existingRawData = getGroupData(props.fieldData.customisationVars, props.fieldData?.config?.groupSettings?.dataLink, -1, true);
        const dataSchema = getCustomisationFieldData(WORKING_ON_NODE_DATA.campaignData, props.fieldData.topNode.id, props.fieldData?.config?.groupSettings?.dataLink);

        console.log("Inserting CSV data. Replace existing:", dataToInsert, replaceExisting, existingRawData, dataSchema);

        if (replaceExisting) {
            // Remove all existing elements from the existingRawData array
            existingRawData.length = 0;
        }

        for (let i = 0; i < dataToInsert.length; i++) {
            addVal(existingRawData, dataSchema.valSchema, props.fieldData.featureData.feature);
            let titleSet = false;
            for (let j = 0; j < dataToInsert[i].length; j++) {
                const cellValue = dataToInsert[i][j];
                const propName = props.csvUploaderData.fields[j].dataLink.split('.').pop(); // Get the last part of the dataLink as the property name
                existingRawData[existingRawData.length - 1][propName] = cellValue;
                if (propName === 'title') {
                    titleSet = true;
                }
            }
            if (!titleSet && existingRawData[existingRawData.length - 1].hasOwnProperty('title') && existingRawData[existingRawData.length - 1].title === '') {
                existingRawData[existingRawData.length - 1].title = dataToInsert[i][0].substring(0, 75); // Set title to the question text (first cell) if title is not provided, limit to 20 characters
            }

        }

        console.log("Data after inserting CSV data:", existingRawData);
        props.onCsvUploaderSelected();
    }

    const getIncludedRows = (data, includedRowsState) => {
        return data.filter((row, index) => includedRowsState[index]);
    }

    return (
        <div className="csv-uploader-content">
            <TabbedPanel
                tabs={tabData}
                switchTabCallback={handleTabSwitch}
                initialTab={0}
                tabWidth="100%"
                tabStyle={2}
            >
                <>
                    {currentTab === 'upload' && (
                        <div className="fl-column">
                            <h5>{props.csvUploaderData.title}</h5>
                            <p>{props.csvUploaderData.description}</p>
                            <div className="fl-column">
                                <div>The format of the CSV file should be as follows:</div>
                                <div className="csv-format">
                                    {props.csvUploaderData.fields.map(field => `${field.name}`).join(', ')}
                                </div>
                                <div>You will see a preview below after you select a CSV file.</div>
                            </div>
                            <div className="fl-row">
                                <div className="shrink">
                                    <div className="bottom-button" onClick={chooseCsvFile}>Choose CSV File</div>
                                </div>
                                <div className="grow"></div>
                            </div>

                            {processedCsvData.length > 0 && 
                                <>
                                    <div className="csv-format">
                                        {processedCsvData.map((row, rowIndex) => (
                                            <div className="fl-row" key={rowIndex}>
                                                <div className="shrink">
                                                    <Toggle
                                                        id={`include-row-${rowIndex}`}
                                                        value={includedNewRows[rowIndex]}
                                                        onToggle={() => {
                                                            setIncludedNewRows(prev => {
                                                                const newState = [...prev];
                                                                newState[rowIndex] = !newState[rowIndex];
                                                                return newState;
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="grow">
                                                    <div className={`csv-row${!includedNewRows[rowIndex] ? ' not-included' : ''}`}>
                                                        {row.map((cell, cellIndex) => (
                                                            <span key={cellIndex} className={`csv-cell${cellIndex === 0 ? ' first-cell' : ''}`}>&quot;{cell}&quot;{cellIndex < row.length - 1 ? ', ' : ''}</span>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="fl-row">
                                        {processedCsvData.filter((row, index) => includedNewRows[index]).length} rows selected for import
                                    </div>
                                    <div className="fl-row">
                                        <div className="shrink">
                                            <div className="bottom-button" onClick={(e) => insertCsvData(getIncludedRows(processedCsvData, includedNewRows), replaceCurrentQuestions)}>Import Data Now</div>
                                        </div>
                                        <div className="shrink">
                                            <div className="fl-row compact">
                                                <div className={`v2-module-field-label`}>Replace Existing Data?</div>
                                                <div className="fl-row">
                                                    <div className="shrink">
                                                        <Toggle
                                                            id={`replace-current-questions`}
                                                            value={replaceCurrentQuestions}
                                                            onToggle={() => setReplaceCurrentQuestions(prev => !prev)}
                                                        />
                                                    </div>
                                                    <div className="grow"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="grow"></div>
                                    </div>
                                </>
                            }

                            <input
                                type="file"
                                accept=".csv"
                                name="image"
                                onChange={handleCsvFile}
                                hidden
                                ref={csvInputRef}
                                id="csvInput"
                            />
                        </div>
                    )}
                    {currentTab === 'download' && (
                        <div className="library-tab-content">
                            <h5>{props.csvUploaderData.title}</h5>
                            <p>{props.csvUploaderData.description}</p>
                            <div>CSV Preview:</div>
                            <div className="csv-format">
                                {existingData.map((row, rowIndex) => (
                                    <div className="fl-row" key={rowIndex}>
                                        <div className="shrink">
                                            <Toggle
                                                id={`include-row-${rowIndex}`}
                                                value={includedExistingRows[rowIndex]}
                                                onToggle={() => {
                                                    setIncludedExistingRows(prev => {
                                                        const newState = [...prev];
                                                        newState[rowIndex] = !newState[rowIndex];
                                                        return newState;
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className="grow">
                                            <div className={`csv-row${!includedExistingRows[rowIndex] ? ' not-included' : ''}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <span key={cellIndex} className={`csv-cell${cellIndex === 0 ? ' first-cell' : ''}`}>&quot;{cell}&quot;{cellIndex < row.length - 1 ? ', ' : ''}</span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="fl-row">
                                {existingData.filter((row, index) => includedExistingRows[index]).length} rows selected for download
                            </div>
                            <div className="fl-row">
                                <div className="shrink">
                                    <div className="bottom-button" onClick={downloadExistingDataAsCsv}>Download CSV File</div>
                                </div>
                                <div className="grow"></div>
                            </div>
                        </div>
                    )}
                </>
            </TabbedPanel>
        </div>
    )
}
export default CsvUploaderContent;